// base rc-switch 1.9.0
import Switch from './Switch';

export default Switch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-switch/index.js
// module id = null
// module chunks = 